import {
  Heading,
  SimpleGrid,
  VStack,
  Text,
  HStack,
  Container,
  Center,
} from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import FancyBearsEmptyMessage from "components/FancyBearsEmptyMessage";
import useAssets from "hooks/useAssets";
import useTranslate from "hooks/useTranslate";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FancyBearCard from "./FancyBearCard";

const FancyBearsContainer = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { fancyBearsInWallet } = useAssets();

  const handleClick = useCallback(
    (tokenId: number) => {
      navigate(`/store/${tokenId}`);
    },
    [navigate]
  );

  if (fancyBearsInWallet === undefined) {
    return (
      <Center h="52">
        <BoldSpinner size="xl" />
      </Center>
    );
  }

  if (fancyBearsInWallet && !fancyBearsInWallet.length) {
    return (
      <Container pt="8" maxW="sm">
        <FancyBearsEmptyMessage />
      </Container>
    );
  }

  return (
    <Container mt="0">
      <VStack spacing="6" w="full">
        <HStack justify="stratch" w="full" gap="4">
          <VStack w="full" align="start" spacing="0.5">
            <Heading fontSize="2xl" fontWeight="800">
              {translate("fancyBears:title")}
            </Heading>
            <Text>{translate("fancyBears:description")}</Text>
          </VStack>
        </HStack>

        <SimpleGrid columns={2} spacing="4" w="full">
          {fancyBearsInWallet.map((tokenId) => (
            <FancyBearCard
              key={tokenId}
              tokenId={tokenId}
              onClick={() => handleClick(tokenId)}
            >
              <Text fontWeight="600">#{tokenId}</Text>
            </FancyBearCard>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default FancyBearsContainer;
